export const environment = {
  production: false,
  apiEndpoint: 'https://api.centralcpd.com',
  gtmKey: 'UA-170049537-1',
  gtmContainerId: 'GTM-MD46FF4',
  contactFormRecipient: 'enquiries@centralcpd.co.uk',
  stripePublishableKey: 'pk_live_n3Knyi7G1ojzJrAtVrFKOvpW',
  brevoKEY: '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',
  touch: true,
  frontendUrl: 'https://www.centralcpd.com',
  stripePrices: {
    individualMonthly: {
      usd: 'price_1TghfEAFU11JHjZiFaZYFy6o',
      eur: 'price_1TxlLrAFU11JHjZijsPtk9An',
      hkd: 'price_1TxlKGAFU11JHjZieGjkKAo5',
      nzd: 'price_1TxlNFAFU11JHjZiJ5Qt0nHs',
      aud: 'price_1TxlHdAFU11JHjZin0afdjme',
      cad: 'price_1TghUUAFU11JHjZig9suQU5P',
      aed: 'price_1TxlPAAFU11JHjZiaybnVNhk'
    },
    individualAnnual: {
      usd: 'price_1Th8LYAFU11JHjZiPcVn0dbE',
      eur: 'price_1TghtcAFU11JHjZi7Bom7Z4Q',
      hkd: 'price_1TghslAFU11JHjZiVotAxjxd',
      nzd: 'price_1Th8JZAFU11JHjZigXJXVDmc',
      aud: 'price_1TghqIAFU11JHjZiwYbGNoE6',
      cad: 'price_1TghrGAFU11JHjZihgO19pfZ',
      aed: 'price_1Th8KoAFU11JHjZiY4dFlg0P'
    },
    practiceMonthly: {
      usd: 'price_1Th8wuAFU11JHjZiXbBP7f3D',
      eur: 'price_1Th8uaAFU11JHjZie13SjSM4',
      hkd: 'price_1Th8tuAFU11JHjZi4JI5oj90',
      nzd: 'price_1Th8vGAFU11JHjZiNAQwrsbJ',
      aud: 'price_1Th8sQAFU11JHjZiv4R2bGmC',
      cad: 'price_1Th8tFAFU11JHjZiur3AAMCk',
      aed: 'price_1Th8vxAFU11JHjZiVGUnd13C'
    },
    practiceAnnual: {
      usd: 'price_1Th8YZAFU11JHjZiSZ3rePft',
      eur: 'price_1Th8UsAFU11JHjZi1CFT5gYP',
      hkd: 'price_1Th8TsAFU11JHjZi18z3OejD',
      nzd: 'price_1Th8WQAFU11JHjZixzwe3XU6',
      aud: 'price_1Th8RpAFU11JHjZilKZiSpvh',
      cad: 'price_1Th8SkAFU11JHjZiOSIDP9LB',
      aed: 'price_1Th8XQAFU11JHjZiwpAZ7pse'
    }
  }
};
